module.exports = __webpack_public_path__ + "img/forgot-pass.5044069e.png";